import { useSearchParams } from 'react-router';
import { ReportActionActionName } from '@amzn/handshake-painter-typescript-client/v1';
import { useAnalyticsContext } from 'src/common/metrics';
import { useReportAction } from 'src/hooks/useReportAction';
import { appendRequestQueryParams } from 'src/utils/links';
import { sendOpenLinkMessage } from 'src/utils/messages';
/**
 * Hook that returns a function to handle off-ramp navigation to Amazon retail pages with analytics tracking.
 *
 * This hook provides a callback that reports user transit actions and opens external links.
 * It combines analytics tracking (via reportAction) with link navigation (via sendOpenLinkMessage)
 * to ensure all off-ramp events are properly tracked before redirecting users.
 * Automatically appends current search params to the destination URL.
 *
 * @returns A function that takes href and source to perform the off-ramp navigation
 */
export const useOffRampToAmazon = () => {
    const rumClient = useAnalyticsContext();
    const { mutate: reportAction } = useReportAction();
    const [searchParams] = useSearchParams();
    return (href, source) => {
        const finalHref = appendRequestQueryParams(searchParams, href);
        reportAction({
            actionName: ReportActionActionName.Transit,
            source,
        });
        sendOpenLinkMessage(rumClient, finalHref);
    };
};
